import request, { IWorkspaceResponse } from './http/request'

const API_PREFIX = '/manage/api/v1'

// 判断登录用户是否是飞手
export const getUserDronePilot = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/users/judge-user-is-pilot`
  const result = await request.get(url)
  return result.data
}

// 获取登录用户部门下的飞手
export const getUserDronePilotsByDepartment = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/users/get-pilot-under-department`
  const result = await request.get(url)
  return result.data
}
